import { useEffect, useRef } from "react";
import { IoMdClose } from "react-icons/io";
import Helper from "../../helper";
import "./PlaceBet.css"; // Import the CSS

const PlaceBet = (props) => {
  const userInfo = Helper();
  const isBack = props?.type === "back";
  const backgroundColor = isBack ? "back-bg" : "lay-bg";
  console.log("PlaceBet props:", props?.BetPlaceData?.team1, props?.BetPlaceData?.team2, props?.BetPlaceData?.team3);
  console.log("PlaceBet props:", props?.BetPlaceData?.runner_name);

  const timeoutRef = useRef(null);

  useEffect(() => {
    // Start 7 second countdown
    timeoutRef.current = setTimeout(() => {
      if (!props?.placing) {
        props?.handleClosePlaceBet?.();
        props?.setShowBetsSlip?.(false);
        props?.setSelection_id?.("");
        props?.setHtmlId?.("");
      }
    }, 7000);

    // Clear timeout if placing starts or on unmount
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);



  return (
    <div
      className={`placebet-container ${backgroundColor}`}
      // style={{ width: "90vw" }}
      style={{
        margin: "0 auto",
        ...(window.innerWidth <= 767
          ? { borderRadius: "15px", width: "100vw", left: 0, right: 0, top: 0, position: "fixed", zIndex: 9999 }
          : { width: "90vw" }),
      }}
    >
      <div className="placebet-header text-[#000]">
        <p className="placebet-title">
          {isBack ? "Back" : "Lay"}: {props?.BetPlaceData?.runner_name}
        </p>
        <IoMdClose
          className="placebet-close"
          onClick={() => props?.handleClosePlaceBet()}
        />
      </div>

      {/* Combine both input groups into one row */}
      <div className="flex justify-between items-center text-center mb-2">
        {/* Odds Input
        <div className="input-group">
          <button className="input-btn">-</button>
          <input
            type="number"
            className="input-field"
            value={props?.BetPlaceData.price}
            style={{ width: "6rem" }}
            readOnly
          />
          <button className="input-btn">+</button>
        </div>

        Stake Input
        <div className="input-group">
          <button
            className="input-btn"
            onClick={() =>
              props?.placeStakeValue(
                props?.StakeValue > 0 ? props?.StakeValue - 100 : 0
              )
            }
          >
            -
          </button>
          <input
            type="number"
            className="input-field"
            value={props?.StakeValue || ""}
            onChange={(e) => props?.placeStakeValue(Number(e.target.value))}
            style={{ width: "6rem" }}
          />
          <button
            className="input-btn"
            onClick={() => props?.placeStakeValue(props?.StakeValue + 100)}
          >
            +
          </button>
        </div> */}

        {/* Odds Input */}
        <div className="flex justify-center items-center h-8 text-[#000]">
          <button className="flex justify-center items-center w-6 h-full bg-[#fff] border border-gray-500">
            -
          </button>
          <input
            type="number"
            className="flex justify-center items-center text-center text-sm w-full h-full border border-gray-500"
            value={props?.BetPlaceData.price}
            style={{ width: "" }}
            readOnly
          />
          <button className="flex justify-center items-center w-6 h-full bg-[#fff] border border-gray-500">
            +
          </button>
        </div>

        {/* Stake Input */}
        <div className="flex justify-center items-center h-8 ml-1 text-[#000]">
          <button
            className="flex justify-center items-center w-6 h-full bg-[#fff] border border-gray-500"
            onClick={() =>
              props?.placeStakeValue(
                props?.StakeValue > 0 ? props?.StakeValue - 100 : 0
              )
            }
          >
            -
          </button>
          <input
            type="number"
            className="flex justify-center items-center text-center text-sm w-full h-full border border-gray-500"
            value={props?.StakeValue || ""}
            onChange={(e) => props?.placeStakeValue(Number(e.target.value))}
            style={{ width: "" }}
          />
          <button
            className="flex justify-center items-center w-6 h-full bg-[#fff] border border-gray-500"
            onClick={() => props?.placeStakeValue(props?.StakeValue + 100)}
          >
            +
          </button>
        </div>
      </div>

      <div className="chip-actions">
        <button
          className="chip-action bg-[#fff] text-[#000] border border-black"
          onClick={() => props?.placeStakeValue(props?.StakeValue + 100)}
        >
          100
        </button>
        <button
          className="chip-action bg-[#fff] text-[#000] border border-black"
          onClick={() => props?.placeStakeValue(props?.StakeValue + 500)}
        >
          500
        </button>
        <button
          className="chip-action bg-[#fff] text-[#000] border border-black"
          onClick={() => props?.placeStakeValue(props?.StakeValue + 1000)}
        >
          1000
        </button>
        <button
          className="chip-action bg-[#fff] text-[#000] border border-black"
          onClick={() => props?.placeStakeValue(props?.StakeValue + 5000)}
        >
          5000
        </button>
        <button
          className="chip-action bg-[#fff] text-[#000] border border-black"
          onClick={() => props?.placeStakeValue(props?.StakeValue + 10000)}
        >
          10000
        </button>
        <button
          className="chip-action bg-[#fff] text-[#000] border border-black"
          onClick={() => props?.placeStakeValue(props?.StakeValue + 50000)}
        >
          50000
        </button>
        {/* <button
          className="chip-action bg-[#fff] text-[#000] border border-black"
          onClick={() => props?.placeStakeValue(props?.StakeValue + 400000)}
        >
          400k
        </button> */}
        {/* <button
          className="chip-action bg-[#fff] text-[#000] border border-black"
          onClick={() => props?.placeStakeValue(props?.StakeValue + 500000)}
        >
          500k
        </button> */}
        {/* <button
          className="chip-action orange"
          onClick={() => props?.placeStakeValue(10)}
        >
          Min Stake
        </button> */}
        {/* <button
          className="chip-action blue"
          onClick={() => props?.placeStakeValue(100000)}
        >
          Max Stake
        </button> */}
        {/* <button className="chip-action purple">All In</button> */}
        <button
          className="chip-action red"
          onClick={() => props?.placeStakeValue(0)}
        >
          Clear
        </button>

      </div>

      {/* <p className="bet-limit">Min Bet: 10 Max Bet: 100000</p> */}

      {userInfo && (
        <div className="action-buttons">
          <button
            className="cancel-btn"
            onClick={() => {
              props?.setShowBetsSlip(false);
              props?.setSelection_id("");
              props?.setHtmlId("");
              props?.handleClosePlaceBet();
            }}
          >
            Cancel
          </button>
          {/* <button
            className="place-btn"
            onClick={() =>
              props?.placing ? console.log("Placing....") : props?.betPlace()
            }
            disabled={
              props?.StakeValue == 0 || props?.StakeValue == undefined
                ? true
                : false
            }
          >
            {props?.placing ? "Placing..." : "Placebet"} ⏱ 0s
            {props?.placing ? "Placing..." : "Placebet"}
          </button> */}
          <button
            className="place-btn flex items-center justify-center bg-indigo-500 text-white font-semibold px-4 py-2 rounded disabled:opacity-70"
            type="button"
            disabled={props?.placing || props?.StakeValue == 0 || props?.StakeValue == undefined}
            onClick={() =>
              props?.placing ? null : props?.betPlace()
            }
          >
            {props?.placing ? (
              <>
                <svg className="mr-3 size-5 animate-spin" viewBox="0 0 24 24" fill="none">
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="white"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="white"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
              </>
            ) : (
              "Placebet"
            )}
          </button>


        </div>


      )}
      {/* Show both team names with their exact profit/loss values from MatchUpdates.js */}
      <div className="flex flex-col gap-1 mt-2">
        {(() => {
          let runners = Array.isArray(props?.BetPlaceData?.runners) && props.BetPlaceData.runners.length > 0
            ? props.BetPlaceData.runners
            : [
              ...(props?.BetPlaceData?.team1 ? [{ runner_name: props.BetPlaceData.team1, exposure: props?.BetPlaceData?.exposure_team1 ?? 0 }] : []),
              ...(props?.BetPlaceData?.team2 ? [{ runner_name: props.BetPlaceData.team2, exposure: props?.BetPlaceData?.exposure_team2 ?? 0 }] : []),
              ...(props?.BetPlaceData?.runner_name && !props?.BetPlaceData?.team1 && !props?.BetPlaceData?.team2
                ? [{ runner_name: props.BetPlaceData.runner_name, exposure: props?.BetPlaceData?.exposure ?? 0 }]
                : []),
            ];
          // For fancy, toss, bookmaker, show single runner with exposure if available
          if (runners.length === 0 && props?.BetPlaceData?.runner_name) {
            runners = [{ runner_name: props.BetPlaceData.runner_name, exposure: props?.BetPlaceData?.exposure ?? 0 }];
          }
          return runners.map((runner, idx) => (
            <div key={runner.runner_name + idx} className="flex items-center justify-between gap-2">
              <span className="text-[#000] text-sm font-bold">{runner.runner_name}</span>
              <span
                className={
                  runner.exposure > 0
                    ? 'text-green-700 text-sm font-bold'
                    : runner.exposure < 0
                      ? 'text-red-600 text-sm font-bold'
                      : 'text-gray-700 text-sm font-bold'
                }
              >
                {typeof runner.exposure === 'number' ? runner.exposure.toFixed(2) : '0.00'}
              </span>
            </div>
          ));
        })()}
      </div>
    </div>
  );
};

export default PlaceBet;
  